<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        Detect
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Detect</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <div v-else class="animated fadeIn" id="detect_detail">
      <b-row>
        <b-col v-if="thumbnail_size == '100%'" lg="7">
          <b-card class="text-center">
            <div slot="header">
              <strong class="float-left">Detection details</strong>
              <small class="float-right" v-if="!add && model.detected_at">Inspection start time : ({{model.detected_at | datetime}})</small>
            </div>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <b-button link block variant="light" @click="copy(model.task_key, 'ticket')" id="tooltip-target-1">
                    <h4> Ticket : {{model.task_key}} </h4>
                  </b-button>
                  <b-tooltip target="tooltip-target-1" triggers="hover">
                    You can copy tickets by pressing FQDN. If there is a problem with the site, you must contact with the ticket to process it quickly
                  </b-tooltip>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <!-- <b-col md="2"></b-col> -->
              <b-col>
                <b-row>
                  <b-col>
                      <b-form-group>
                      <label for="ph_username" v-b-tooltip.hover>Name</label><br>
                      <label for="ph_domain">{{model && model.site && model.site.name || 'No current data'}}</label>
                    </b-form-group>
                  </b-col>
                </b-row>
                <hr>
                <b-row>
                  <b-col>
                    <b-form-group>
                      <label for="ph_domain" v-b-tooltip.hover>Check Domain</label><br>
                      <label for="ph_domain">{{model.domain}}</label>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col md="3">
                <b-form-group>
                  <label v-b-tooltip.hover title="Indicates the degree of risk of the pattern">
                    Level
                    <span>
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </label>
                  <br>
                  <b-badge variant="danger" v-if="codes.WMDS_LEVEL(model.level, 'EN') == 'high'"> {{codes.WMDS_LEVEL(model.level, "EN")}}</b-badge>
                  <b-badge variant="primary" v-else> {{codes.WMDS_LEVEL(model.level, "EN")}}</b-badge>
                </b-form-group>
              </b-col>

              <b-col :md="model && codes.WMDS_TYPE[model.type] == 'MD5' || codes.WMDS_TYPE[model.type] == 'Regex' ? 4 : 3">
                <label v-b-tooltip.hover title="Describes the type of pattern">
                  Detect Type
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && model.type">{{codes.WMDS_TYPE[model.type]}}</p>
              </b-col>
              <b-col :md="model && codes.WMDS_TYPE[model.type] == 'MD5' || codes.WMDS_TYPE[model.type] == 'Regex' ? 4 : 3">
                <label v-b-tooltip.hover title="Indicates how many site links the detected page has traversed.">
                  DEPTH
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && model.type">{{depth}}</p>
              </b-col>
              <b-col v-if="model && codes.WMDS_TYPE[model.type] != 'MD5' && codes.WMDS_TYPE[model.type] != 'Regex'" md="3">
                <!-- URL, String -->
                <label v-if="codes.WMDS_TYPE[model.type] == 'URL'" v-b-tooltip.hover title="Displays the line on which the pattern was detected on the site. This line is the line number with the site's dynamic loading completed.">
                  Line
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && codes.WMDS_TYPE[model.type] == 'URL'">{{row_id + 1 || '-'}}</p>

                <!-- MD5 -->
                <!-- <p v-if="model && codes.WMDS_TYPE[model.type] == 'MD5'">{{row_id + 1 || '-'}}</p> -->

                <!-- Regex -->
                <!-- <label v-if="codes.WMDS_TYPE[model.type] == 'Regex'" v-b-tooltip.hover title="Displays the number matched by a regular expression">
                  매칭 개수
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && codes.WMDS_TYPE[model.type] == 'Regex'">{{row_count || '-'}}</p> -->
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col md="12">
                <table class="table table-sm table-dark">
                  <thead>
                    <tr>
                      <th scope="col">Method of integrity verification</th>
                      <th scope="col">VALUE</th>
                      <th scope="col">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in ([{ type : 'MD5', value : model.md5, desc : 'Detected page url' }, { type : 'URL HASH', value : model.url_hash, desc : 'Detected page url hash' }] || [])" :key="index">
                      <th scope="row">{{row.type}}</th>
                      <th scope="row">{{row.value}}</th>
                      <th scope="row">{{row.desc ? row.desc : '-'}}</th>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <!-- <b-col md="6">
                <b-form-group>
                  <label for="ph_count" v-b-tooltip.hover>HASH</label><br>
                  <label for="ph_ext" v-if="model && model.detail_data">{{model.url_hash}}</label>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="ph_count" v-b-tooltip.hover>MD5</label><br>
                  <label for="ph_ext" v-if="model && model.detail_data">{{model.md5}}</label>
                </b-form-group>
              </b-col> -->
            </b-row>
            <hr>
            <b-row>
              <b-col md="12">
                <h3>
                  <p for="ph_count" v-b-tooltip.hover>Detected Pattern</p>
                  <span v-if="model.data && (model.f1code || model.ucode)">{{model.f1code || model.ucode}}</span>
                </h3>
              </b-col>
            </b-row>
            <hr>
            <b-button size="sm" variant="danger" class="float-left" @click="confirm = true"> Remove </b-button>
            <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
          </b-card>
        </b-col>
        <b-col lg="12" :xl="thumbnail_size == '100%' ? 5 : 12">
          <b-card>
            <div slot="header" class="text-center">
              <strong>ScreenShot</strong>
            </div>
            <b-row class="text-center">
              <b-col md="12">
                <a @click="toggle_thumbnail" >
                  <img :src="image" style="max-width:850px; cursor:pointer;" :style="{ width: thumbnail_size }">
                </a>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card style="max-height: 400px; overflow: auto;">
            <div slot="header">
              <strong>Detect</strong>
              <label class="float-right" v-if="model">{{depth}} Depth</label>
            </div>
            <b-row>
              <b-col md="12">
                <pre slot="body" style="max-width: 100%; max-height: 500px; overflow:auto;">
                  <div v-for="(item, index) in model.url_tree" :key="index" :style="{ 'padding-left' : index * 10 + 'px'}">Depth : {{index+1}} ==> {{item}}
                  </div>
                </pre>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="1" xl="12">
          <b-card>
            <div slot="header">
              <strong>HTML Data</strong>
              <b-button class="float-right" size="sm" variant="primary" @click="save_rs"> HTML Source Download </b-button>
              <b-button class="float-right mr-2" size="sm" variant="warning" @click="copy(model.data, 'html source code')"> Copy </b-button>
              <b-button class="btn-add float-right mr-2" size="sm" variant="success" @click="heilith"> Detected pattern Selecting </b-button>
            </div>
            <b-row>
              <b-col md="12" id>
                <!-- <img src="img/texteditorline.png"> -->
                <!-- <b-form-textarea
                    style="overflow: auto;"
                    id="data"
                    :rows="50"
                    v-model="model.data"
                    @change="selecting"
                  >
                </b-form-textarea> -->

                <div>
                  <!-- <pre id="data" slot="body" style="width: 3000px; overflow: visible;">{{model.data}}</pre> -->
                  <!-- <text-highlight style="width: 3000px; overflow: visible;" :queries="[this.model.f1code || this.model.ucode]">
                    {{ model.data }}
                  </text-highlight> -->
                  <htmlViewer :type="codes.WMDS_TYPE[model.type]" ref="html_viewer" @line="x => row_id = x" :html="model.data" :search="this.model.f1code || this.model.ucode" effect='text-danger' />
                </div>
                <!-- <button onclick="TLN.append_line_numbers('test')"> NUMBERIFY! </button>
                <div id="wrapper">
                    <textarea id="test" class="banana-cake"></textarea>
                </div> -->
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-modal title="Detect Data Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
        This operation cannot be reversed
      </b-modal>
    </div>
    <!-- load custom -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
